import React from 'react'

import { useModalData } from '../../../components/modals/ModalsContext'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import { useGenerateActivatedQRCodes } from './_requests/generateActivatedQRCodes'

const GenerateActivatedQRCodesForm = () => {
  const data = useModalData() || {}
  const [activate, { loading, error }] = useGenerateActivatedQRCodes()

  return (
    <Form loading={loading} onSubmit={activate} initialState={data}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error} label="Gerar e ativar" />
    </Form>
  )
}

export default GenerateActivatedQRCodesForm
